// extracted by mini-css-extract-plugin
export default {"container":"index_container__SCpNh","endorsers":"index_endorsers__pcOeh","sktcontainer":"index_sktcontainer__t8x38"};